export class HideCpaDropdown {
  // TODO: can be cleaner NO DOM MANIPULATION
  hideCPA () {
    if (document.querySelector('#bidStrategyDropdown').getElementsByTagName('select')[0].value !== 'Target CPA') {
      document.querySelector('.targetCpa').classList.add('hidden')
    } else {
      document.querySelector('.targetCpa').classList.remove('hidden')
    }
  }

  checkDropdownValue () {
    if (document.querySelector('#bidStrategyDropdown')) {
      if ((document.querySelector('#bidStrategyDropdown').getElementsByTagName('select')[0].value !== null)) {
        if (document.querySelector('#bidStrategyDropdown').getElementsByTagName('select')[0].value !== 'Target CPA') {
          document.querySelector('.targetCpa').classList.add('hidden')
        }
        document.querySelector('#bidStrategyDropdown').getElementsByTagName('select')[0].addEventListener('change', this.hideCPA)
      }
    }
  }
}
